/* eslint react/jsx-props-no-spreading: 0 */

// import 'react-native-polyfill';
import 'core-js/features/typed-array/from';

import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import React from 'react';
import {
  Platform,
  // BackHandler,
  Text,
  TextInput,
  View,
  Dimensions,
  ActivityIndicator,
  StatusBar,
  // KeyboardAvoidingView,
} from 'react-native';
import Orientation from 'react-native-orientation-locker';
import { createMemoryHistory, createBrowserHistory } from 'history';
import { Amplify, API, Storage } from 'aws-amplify';
// import Auth from '@aws-amplify/auth';
// TODO: restore 'rehydrated' functionality
// import { Rehydrated } from 'aws-appsync-react';
import { ApolloProvider } from '@apollo/client';

// import './assets/fonts/FontAwesome.ttf';
import './assets/fonts/Rubik-Regular.ttf';
import './assets/fonts/Rubik-Bold.ttf';
import './assets/fonts/Rubik-SemiBold.ttf';
import AORTypes from './types';
import { Router, Route, Routes, useLocation } from './routing';
// import './audio-player';
import { setI18nConfig, i18n, translate } from './locales/i18n';
import { language } from './localization';
import styles from './styles';
import Uploader from './Uploader';
import Analytics from './modules/service/Analytics';
// import History from './modules/global/History';
import withAuthentication from './modules/global/Authentication';
import withConfiguration from './modules/global/Configuration';
import withUserData from './modules/global/UserData';
// import withBanner from './modules/global/Banner';
import AmplifyConfig from './backends/AmplifyConfig';
// import AuthConfig from './backends/AuthConfig';
import { AppSyncClientUnauthenticated } from './backends/AppSyncClient';
import { MainContext } from './context';

import {
  SignIn,
  SignUp,
  SignConfirm,
  Activate,
  Forgot,
  ForgotSubmit,
  Profile,
  ExternalAuth,
  Logout,
} from './views/user';
import {
  AppInfo,
  AppPreview,
  Purchase,
  Review,
  Reviews,
  PublisherInfoSwitch,
  AppView,
  AppQuery,
} from './views/consumer/index';
import {
  Help,
  Support,
  About,
  AboutUs,
  Careers,
  Investors,
  Legal,
  Privacy,
  Contact,
} from './views/company';
import {
  Main,
  Welcome,
  Search,
  Home,
  MyApps,
  Settings,
  SettingsAddLang,
} from './views/consumer/index2';
// import {
//   UnauthMyApps,
// } from './views/unauth/consumer';
import {
  PublisherQuestions,
  PublisherReviews,
  PublisherStatistics,
  PublisherSettings,
  PublisherMethod,
  PublisherAppAdded,
  PublisherAppApproved,
} from './views/publisher';
// import {
//   UnauthPublisherApps,
// } from './views/unauth/publisher';
import {
  PublisherToken,
  PublisherApps,
  PublisherAppAdd,
  PublisherAdd,
  PublisherAppEdit,
  PublisherEndpointAdd,
  PublisherEndpointEdit,
  PublisherLegEdit,
  PublisherImageEdit,
} from './views/publisher/create';
import {
  PendingUsers,
  PendingApps,
  PendingReviews,
  // AuditorAccess,
  AuditorHome,
  AppViewWrapper,
  AppApprove,
  AppDecline,
} from './views/auditor/index';
import Page404 from './views/Page404';
import NotYet from './views/NotYet';
import {
  withSideMenuConsumer,
  withSideMenuPublisher,
  withSideMenuAuditor,
} from './components/nav/SideMenu';

// TODO(clairbee): continue experimenting with loading 'user', 'company' and 'publisher' asynchronously
// let SignIn = () => {
//   import(/* webpackChunkName: "user", webpackMode: "lazy", webpackPrefetch: true */ './views/user/index').then((module) => {
//     SignIn = module.SignIn;
//   });

//   return SignIn();
// };

const MSignIn = withSideMenuConsumer(SignIn);
const MSignUp = withSideMenuConsumer(SignUp);
const MSignConfirm = withSideMenuConsumer(SignConfirm);
const MActivate = withSideMenuConsumer(Activate);
const MForgot = withSideMenuConsumer(Forgot);
const MForgotSubmit = withSideMenuConsumer(ForgotSubmit);
const MProfile = withSideMenuConsumer(Profile);
const MExternalAuth = withSideMenuConsumer(ExternalAuth);
const MLogout = withSideMenuConsumer(Logout);

const MAppInfo = withSideMenuConsumer(AppInfo);
const MPurchase = withSideMenuConsumer(Purchase);
const MReview = withSideMenuConsumer(Review);
const MReviews = withSideMenuConsumer(Reviews);
const MAppPreview = withSideMenuConsumer(AppPreview);

const MMain = withSideMenuConsumer(Main);
const MSearch = withSideMenuConsumer(Search);
const MWelcome = withSideMenuConsumer(Welcome);
const MHome = withSideMenuConsumer(Home);
const MMyApps = withSideMenuConsumer(MyApps);
const MSettings = withSideMenuConsumer(Settings);
const MSettingsAddLang = withSideMenuConsumer(SettingsAddLang);
const MHelp = withSideMenuConsumer(Help);
const MSupport = withSideMenuConsumer(Support);
const MAbout = withSideMenuConsumer(About);
const MAboutUs = withSideMenuConsumer(AboutUs);
const MCareers = withSideMenuConsumer(Careers);
const MInvestors = withSideMenuConsumer(Investors);
const MLegal = withSideMenuConsumer(Legal);
const MPrivacy = withSideMenuConsumer(Privacy);
const MContact = withSideMenuConsumer(Contact);

// const MUnauthMyApps = withSideMenuConsumer(UnauthMyApps);

const MPublisherQuestions = withSideMenuPublisher(PublisherQuestions);
const MPublisherReviews = withSideMenuPublisher(PublisherReviews);
const MPublisherStatistics = withSideMenuPublisher(PublisherStatistics);
const MPublisherSettings = withSideMenuPublisher(PublisherSettings);
const MPublisherMethod = withSideMenuPublisher(PublisherMethod);
const MPublisherAppAdded = withSideMenuPublisher(PublisherAppAdded);
const MPublisherAppApproved = withSideMenuPublisher(PublisherAppApproved);

const MPublisherHelp = withSideMenuPublisher(Help);
const MPublisherSupport = withSideMenuPublisher(Support);
const MPublisherAbout = withSideMenuPublisher(About);
const MPublisherAboutUs = withSideMenuPublisher(AboutUs);
const MPublisherCareers = withSideMenuPublisher(Careers);
const MPublisherInvestors = withSideMenuPublisher(Investors);
const MPublisherLegal = withSideMenuPublisher(Legal);
const MPublisherPrivacy = withSideMenuPublisher(Privacy);
const MPublisherContact = withSideMenuPublisher(Contact);

// const MUnauthPublisherApps = withSideMenuPublisher(UnauthPublisherApps);

const MPublisherToken = withSideMenuPublisher(PublisherToken);
const MPublisherApps = withSideMenuPublisher(PublisherApps);
const MPublisherAdd = withSideMenuPublisher(PublisherAdd);
const MPublisherAppAdd = withSideMenuPublisher(PublisherAppAdd);
const MPublisherAppEdit = withSideMenuPublisher(PublisherAppEdit);
const MPublisherEndpointAdd = withSideMenuPublisher(PublisherEndpointAdd);
const MPublisherEndpointEdit = withSideMenuPublisher(PublisherEndpointEdit);
const MPublisherLegEdit = withSideMenuPublisher(PublisherLegEdit);
const MPublisherImageEdit = withSideMenuPublisher(PublisherImageEdit);

const MPendingUsers = withSideMenuAuditor(PendingUsers);
const MPendingApps = withSideMenuAuditor(PendingApps);
const MPendingReviews = withSideMenuAuditor(PendingReviews);
// const MAuditorAccess = withSideMenuAuditor(AuditorAccess);
const MAuditorHome = withSideMenuAuditor(AuditorHome);
const MAppViewWrapper = withSideMenuAuditor(AppViewWrapper);
const MAppApprove = withSideMenuAuditor(AppApprove);
const MAppDecline = withSideMenuAuditor(AppDecline);

const MAppView = withSideMenuConsumer(AppView);
const MAppQuery = withSideMenuConsumer(AppQuery);
const MPage404 = withSideMenuConsumer(Page404);
const MNotYet = withSideMenuConsumer(NotYet);

const FrontPage = Platform.OS === 'web' ? MMain : MHome;

setI18nConfig();
i18n.changeLanguage(language())
  .catch((error) => {
    console.error('i18n.changeLanguage() failed');
    console.log(error);
  });

Amplify.configure(AmplifyConfig);
// Auth.signIn(AuthConfig);
// Auth.configure(AuthConfig);
// API.configure(AmplifyConfig); // TODO(clairbee): Is this needed?
// Storage.configure(AmplifyConfig); // TODO(clairbee): Is this needed?

if (Platform.OS !== 'web') {
  const NetInfo = import('@react-native-community/netinfo');

  NetInfo.fetch().then((state) => {
    console.log('Connection type', state.type);
    console.log('Is connected?', state.isConnected);
  });
}

if (Platform.OS !== 'ios') {
  const customTextProps = {
    style: {
      fontFamily: styles.primaryFontRegular,
    },
  };

  const originalCreateElement = React.createElement;
  React.createElement = function createElement(type, props, ...children) {
    if (type === Text || type === TextInput) {
      const { style, ...restProps } = props || {};
      return originalCreateElement(type, {
        ...restProps,
        style: [customTextProps.style, style],
      }, ...children);
    }
    return originalCreateElement(type, props, ...children);
  };
}

export const orientationPortrait = 'PORTRAIT';
export const orientationLandscape = 'LANDSCAPE';

class MainScreen extends React.Component {
  constructor(props, context) {
    super(props, context);

    const {
      user,
      userHash,
      userIdentity,
      userData,
      updateUserData,
      onUpdateUser,
      config,
    } = this.props;

    this.getUploader = this.getUploader.bind(this);
    this.getAnalyticsService = this.getAnalyticsService.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
    this.onLayout = this.onLayout.bind(this);
    // this.orientationDidChange = this.orientationDidChange.bind(this);

    const history = Platform.OS === 'web' ? createBrowserHistory() : createMemoryHistory();
    // const history = createMemoryHistory();

    const initialLayoutOrientation = Platform.OS === 'web' ? orientationLandscape : Orientation.getInitialOrientation();
    const initialDirection = initialLayoutOrientation === orientationPortrait ? 'column' : 'row';

    this.state = {
      // layoutOrientation: Platform.OS === 'web' ? orientationLandscape : Orientation.getInitialOrientation(),
      viewStyle: { height: Dimensions.get('window').height },
      uploader: null,
      analyticsService: null,
      authContext: {},
      config,
      location: history.location,
      // location: {
      //   pathname: '/',
      //   search: '',
      //   hash: '',
      //   state: null,
      //   key: 'default',
      // },
      locationPathname: '/',
      user,
      userHash,
      userIdentity,
      userData,
      updateUserData,
      onUpdateUser,
      layoutOrientation: initialLayoutOrientation,
      direction: initialDirection,
    };

    this.setState = this.setState.bind(this);

    // this.fsm = Authentication.getAuthMachine(() => this.state, this.setState);

    // keep the viewport out of the state so that its changes do not influence the child components
    this.viewport = null;

    history.listen(({ action, location }) => {
      console.log('history onChange');
      console.log(action);
      console.log(location);
      this.setState({
        location,
        locationPathname: location.pathname,
      });
    });

    this.mainContext = {
      createAppPage: {},
      history,
    };

    this.backHandler = null;
  }

  componentDidMount() {
    console.log('MainScreen componentDidMount');

    // History
    if (Platform.OS !== 'web') {
      // TODO(clairbee): investigate why GuideMaze didn't have it for hardware only
      this.backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
        if (this.mainContext.history) {
          this.mainContext.history.goBack();
        }
        return true;
      });
    }

    // this.fsm.start();

    // // Orientation
    // try {
    //   // Orientation.lockToPortrait();
    //   Orientation.addOrientationListener(this.orientationDidChange);
    // } catch (error) {
    //   // this is web
    // }

    // Layout
    Dimensions.addEventListener('change', () => {
      this.onLayout();
    });
  }

  componentDidUpdate(prevProps, _prevState) {
    const {
      layoutOrientation,
      user,
      userHash,
      userIdentity,
      userData,
      updateUserData,
      onUpdateUser,
      config,
    } = this.props;
    const {
      layoutOrientation: prevLayoutOrientation,
      user: prevUser,
      userHash: prevUserHash,
      userIdentity: prevUserIdentity,
      userData: prevUserData,
      updateUserData: prevUpdateUserData,
      onUpdateUser: prevOnUpdateUser,
      config: prevConfig,
    } = prevProps;

    // if (layoutOrientation !== prevLayoutOrientation) {
    //   this.forceUpdate();
    // }

    if (user !== prevUser || userHash !== prevUserHash || userIdentity !== prevUserIdentity) {
      this.setState({
        user,
        userHash,
        userIdentity,
      });
    }

    if (userData !== prevUserData || (userData !== null && prevUserData !== null && userData.name !== prevUserData.name) || updateUserData !== prevUpdateUserData || onUpdateUser !== prevOnUpdateUser) {
      this.setState({
        userData, updateUserData, onUpdateUser,
      });
    }

    if (config.hash !== prevConfig.hash || config.verListApps !== prevConfig.verListApps) {
      this.setState({
        config,
      });
    }
  }

  componentWillUnmount() {
    // Layout
    Dimensions.removeEventListener('change');

    // // Orientation
    // try {
    //   Orientation.removeOrientationListener(this.orientationDidChange);
    // } catch (error) {
    //   // this is web
    // }

    // History
    if (Platform.OS !== 'web') {
      this.backHandler.remove();
    }
  }

  onLayout(event) {
    console.log('onLayout');
    console.log(event);

    const { layoutOrientation } = this.state;
    let width;
    let height;

    if (event) {
      width = event.nativeEvent.layout.width;
      height = event.nativeEvent.layout.height;
      if (height === 0) {
        height = Dimensions.get('window').height;
      }
      if (width === 0) {
        width = Dimensions.get('window').width;
      }
    }

    if (Platform.OS === 'web') {
      const winHeight = window.innerHeight;
      console.log('winHeight', winHeight);
      // if (height === undefined || winHeight < height) {
      height = winHeight;
      // }
      const winWidth = window.innerWidth;
      console.log('winWidth', winWidth);
      // if (width === undefined || winWidth < width) {
      width = winWidth;
      // }
    }

    if (!height || !width) {
      return;
    }

    let newLayoutOrientation;
    if (layoutOrientation === orientationPortrait && width > height * 1.2) {
      newLayoutOrientation = orientationLandscape;
    } else if (layoutOrientation === orientationLandscape && width * 1.2 < height) {
      newLayoutOrientation = orientationPortrait;
    } else {
      newLayoutOrientation = layoutOrientation;
    }

    const viewStyle = { height, width };


    // this.forceUpdate();

    this.setState({
      width,
      height,
      layoutOrientation: newLayoutOrientation,
      direction: newLayoutOrientation === orientationPortrait ? 'column' : 'row',
      viewStyle,
    });
  }

  // // Again the type declaration 'orientation' is only for TypeScript
  // orientationDidChange(/* orientation: */ orientation) {
  //   console.log('orientationDidChange');
  //   console.log(orientation);
  //   this.setState({ layoutOrientation: orientation });
  // }

  onViewportChange(viewport) {
    console.log('onViewportChange');
    console.log(viewport);
    // console.trace();

    let reload = false;

    // this.viewport = viewport;
    if (!this.viewport) {
      this.viewport = {};
      reload = true;
    }

    if (viewport.mapType) {
      this.viewport.mapType = viewport.mapType;
    }
    if (viewport.searchName) {
      this.viewport.searchName = viewport.searchName;
    }
    if (viewport.latitude !== undefined) {
      this.viewport.latitude = viewport.latitude;
      this.viewport.longitude = viewport.longitude;
    }
    if (viewport.latitudeDelta !== undefined) {
      this.viewport.latitudeDelta = viewport.latitudeDelta;
      this.viewport.longitudeDelta = viewport.longitudeDelta;
    }

    if (reload) {
      this.forceUpdate();
    }
  }

  getUploader() {
    return this.uploader;
  }

  getAnalyticsService() {
    return this.analyticsService;
  }

  render() {
    console.log('MainScreen render');
    console.log(this.props);

    // let direction = 'row';
    const {
      location, viewStyle, layoutOrientation, user, direction,
    } = this.state;

    // if (layoutOrientation === orientationPortrait) {
    //   direction = 'column';
    // }

    const common = (props) => ({
      ...this.mainContext,
      ...this.state,
      ...props,
      // direction,
      viewport: this.viewport,
      onViewportChange: this.onViewportChange,
      getUploader: this.getUploader,
      getAnalyticsService: this.getAnalyticsService,
    });

    // if (this.props.history && this.props.history.location) {
    // if (this.props.location) {
    //   // const tailIndex = this.props.history.location.pathname.indexOf('/index.');
    //   const tailIndex = this.props.location.pathname.indexOf('/index.');
    //   if (tailIndex !== -1) {
    //     // this.props.history.location.pathname = this.props.history.location.pathname.substring(0, tailIndex);
    //     this.props.location.pathname = this.props.location.pathname.substring(0, tailIndex);
    //   }
    // }
    // if (this.props.history) {
    //   // const tailIndex = this.props.history.location.pathname.indexOf('/index.');
    //   console.log('found history');
    //   console.log(this.props.history);
    //   const tailIndex = this.props.history.location.pathname.indexOf('/index.');
    //   if (tailIndex !== -1) {
    //     this.props.history.location.pathname = this.props.history.location.pathname.substring(0, tailIndex);
    //   }
    // }

    return (
      <>
        <StatusBar hidden />
        <Uploader
          user={user}
          ref={(uploader) => {
            this.uploader = uploader;
          }}
        />
        <Analytics
          {...common({})}
          ref={(analyticsService) => {
            this.analyticsService = analyticsService;
          }}
        />
        {/* TODO(clairbee): add Rehydrated here */}
        <MainContext.Provider style={styles.view.main} value={this.mainContext}>
          {/* <Configuration
                {...common({})}
                ref={(configuration) => {
                  if (!configuration) {
                    return;
                  }
                  console.log('configuration');
                  console.log('mainContext');
                  console.log(this.mainContext);
                }}
              /> */}
          {/* <UserData
                {...common({})}
                ref={(userData) => {
                  if (!userData) {
                    return;
                  }
                  console.log('userData');
                  console.log('mainContext');
                  console.log(this.mainContext);
                }}
              /> */}
          <View
            // <KeyboardAvoidingView
            //   behavior="padd
            style={[styles.view.main, viewStyle]}
            onLayout={this.onLayout}
          >
            <Router
              location={location}
              style={styles.view.main}
              history={this.mainContext.history}
              navigator={this.mainContext.history}
              base
            >
              {/* TODO(clairbee): implement side menu right here */}
              <Routes location={location}>
                <Route path="/signin/*" element={<MSignIn {...common({})} />} />
                <Route path="/signup/*" element={<MSignUp {...common({})} />} />
                <Route path="/confirm/*" element={<MSignConfirm {...common({})} />} />
                <Route path="/activate/:username/:code" element={<MActivate {...common({})} />} />
                <Route path="/activate/:username/:code/:redirect+" element={<MActivate {...common({})} />} />
                <Route path="/auth/:provider" element={<MExternalAuth {...common({})} />} />
                <Route path="/auth/:provider/:redirect+" element={<MExternalAuth {...common({})} />} />
                <Route path="/logout/*" element={<MLogout {...common({})} />} />
                <Route path="/forgotsubmit" element={<MForgotSubmit {...common({})} />} />
                <Route path="/forgotsubmit/*" element={<MForgotSubmit {...common({})} />} />
                <Route path="/forgot" element={<MForgot {...common({})} />} />
                <Route path="/forgot/*" element={<MForgot {...common({})} />} />
                <Route path="/profile" element={<MProfile {...common({})} />} />
                <Route path="/settings" element={<MSettings {...common({})} />} />
                <Route path="/settings/addlang" element={<MSettingsAddLang {...common({})} />} />
                <Route path="/questions" element={<MPublisherQuestions {...common({})} />} />
                <Route path="/reviews" element={<MPublisherReviews {...common({})} />} />
                <Route path="/statistics" element={<MPublisherStatistics {...common({})} />} />
                <Route path="/publishersettings" element={<MPublisherSettings {...common({})} />} />
                <Route path="/publishermethod/:method" element={<MNotYet {...common({})} />} />
                {/* <Route exact path="/publishermethod/:method" element={<MPublisherMethod {...common({})} />} /> */}
                <Route path="welcome" element={<MWelcome {...common({})} />} />
                <Route path="/" element={<FrontPage {...common({})} />} />
                <Route path="/index.html" element={<MMain {...common({})} />} />
                <Route path="/index.:lang.html" element={<MMain {...common({})} />} />
                <Route path="/ai-agents" element={<MHome {...common({})} />} />
                <Route path="/ai-agents/*" element={<MSearch {...common({})} />} />
                <Route
                  path="/publisher/*"
                  element={<PublisherInfoSwitch {...common({})} />}
                />
                <Route path="/ai-agent/online/:uuid/index.*.html" element={<MAppView {...common({})} />} />
                <Route path="/ai-agent/:uuid" element={<MAppInfo {...common({})} />} />
                <Route path="/review/:uuid" element={<MReview {...common({})} />} />
                <Route path="/reviews/:uuid" element={<MReviews {...common({})} />} />
                <Route path="/help" element={<MHelp {...common({})} />} />
                <Route path="/help/*" element={<MHelp {...common({})} />} />
                <Route path="/support" element={<MSupport {...common({})} />} />
                <Route path="/support/*" element={<MSupport {...common({})} />} />
                <Route path="/about" element={<MAbout {...common({})} />} />
                <Route path="/about/*" element={<MAbout {...common({})} />} />
                <Route path="/aboutus" element={<MAboutUs {...common({})} />} />
                <Route path="/aboutus/*" element={<MAboutUs {...common({})} />} />
                <Route path="/careers" element={<MCareers {...common({})} />} />
                <Route path="/careers/*" element={<MCareers {...common({})} />} />
                <Route path="/investors" element={<MInvestors {...common({})} />} />
                <Route path="/investors/*" element={<MInvestors {...common({})} />} />
                <Route path="/legal" element={<MLegal {...common({})} />} />
                <Route path="/legal/*" element={<MLegal {...common({})} />} />
                <Route path="/privacy" element={<MPrivacy {...common({})} />} />
                <Route path="/privacy/*" element={<MPrivacy {...common({})} />} />
                <Route path="/contact" element={<MContact {...common({})} />} />
                <Route path="/contact/*" element={<MContact {...common({})} />} />
                <Route path="/publisherhelp" element={<MPublisherHelp {...common({})} />} />
                <Route path="/publishersupport" element={<MPublisherSupport {...common({})} />} />
                <Route path="/publisherabout" element={<MPublisherAbout {...common({})} />} />
                <Route path="/publisheraboutus" element={<MPublisherAboutUs {...common({})} />} />
                <Route path="/publishercareers" element={<MPublisherCareers {...common({})} />} />
                <Route path="/publisherinvestors" element={<MPublisherInvestors {...common({})} />} />
                <Route path="/publisherlegal" element={<MPublisherLegal {...common({})} />} />
                <Route path="/publisherprivacy" element={<MPublisherPrivacy {...common({})} />} />
                <Route path="/publishercontact" element={<MPublisherContact {...common({})} />} />
                <Route path="/appadded" element={<MPublisherAppAdded {...common({})} />} />
                <Route path="/approved/*" element={<MPublisherAppApproved {...common({})} />} />
                <Route path="/apppreview/:uuid" element={<MAppPreview {...common({})} />} />
                <Route path="/ai-agent/online/*" element={<MAppQuery {...common({})} />} />

                {/* The below items duplicate all paths from the switch of publisherized users. */}
                {/* If something is missing here, those pages will get 'Page404' as well. */}
                {/* <Route path="/ai-agent/online/:uuid" element={<MNotYet {...common({})} />} /> */}
                <Route path="/purchase" element={<MNotYet {...common({})} />} />
                {/* <Route exact path="/saved-ai-agents" /> */}
                {/* <Route path="/my-ai-agents" element={<MNotYet {...common({})} />} /> */}
                <Route path="/add" element={<MNotYet {...common({})} />} />
                <Route path="/addapp" element={<MNotYet {...common({})} />} />
                <Route path="/editapp/*" element={<MPublisherToken {...common({})} />} />
                <Route path="/addendpoint" element={<MNotYet {...common({})} />} />
                <Route path="/editendpoint" element={<MNotYet {...common({})} />} />
                <Route path="/editleg" element={<MNotYet {...common({})} />} />
                <Route path="/editimage" element={<MNotYet {...common({})} />} />

                {/* The below item must be the last one. It catches everything else. */}
                <Route path="/" element={<MPage404 {...common({})} />} />
                {user ? (
                  <>
                    <Route path="/saved-ai-agents" element={<MMyApps {...common({})} />} />
                    <Route path="/token" element={<MPublisherToken {...common({})} />} />
                    <Route path="/my-ai-agents" element={<MPublisherApps {...common({})} />} />
                    <Route path="/ai-agent-review/*" element={<MAppViewWrapper {...common({})} />} />
                    <Route path="/auditor" element={<MAuditorHome {...common({})} />} />
                    <Route path="/pendingusers" element={<MPendingUsers {...common({})} />} />
                    <Route path="/pendingapps" element={<MPendingApps {...common({})} />} />
                    <Route path="/pendingreviews" element={<MPendingReviews {...common({})} />} />
                    <Route path="/appapprove/*" element={<MAppApprove {...common({})} />} />
                    <Route path="/appdecline/*" element={<MAppDecline {...common({})} />} />

                    {/* <Route path="/purchase/:uuid/:method/:native" element={<MPurchase {...common({})} />} />
                    <Route path="/purchase/:uuid" element={<MPurchase {...common({})} />} />
                    <Route path="/add" element={<MPublisherAdd {...common({})} />} />
                    <Route path="/addapp" element={<MPublisherAppAdd {...common({})} />} />
                    <Route path="/editapp/:uuid" element={<MPublisherAppEdit {...common({})} />} />
                    <Route path="/editapp/:uuid/:page" element={<MPublisherAppEdit {...common({})} />} />
                    <Route path="/addendpoint/:appUuid" element={<MPublisherEndpointAdd {...common({})} />} />
                    <Route path="/editendpoint/:appUuid/:uuid" element={<MPublisherEndpointEdit {...common({})} />} />
                    <Route path="/editleg/:appUuid/:uuid/:index" element={<MPublisherLegEdit {...common({})} />} />
                    <Route path="/editimage/:appUuid/:uuid/:imageUuid" element={<MPublisherImageEdit {...common({})} />} /> */}
                  </>
                ) : (
                  <>
                    <Route path="/saved-ai-agents" element={<MSignIn forced {...common({})} />} />
                    <Route path="/token" element={<MSignIn forced {...common({})} />} />
                    <Route path="/my-ai-agents" element={<MSignIn forced {...common({})} />} />
                    <Route path="/ai-agent-review/*" element={<MSignIn forced {...common({})} />} />
                    <Route path="/auditor" element={<MSignIn forced {...common({})} />} />
                    <Route path="/pendingusers" element={<MSignIn forced {...common({})} />} />
                    <Route path="/pendingapps" element={<MSignIn forced {...common({})} />} />
                    <Route path="/pendingreviews" element={<MSignIn forced {...common({})} />} />
                    <Route path="/appapprove/*" element={<MSignIn forced {...common({})} />} />
                    <Route path="/appdecline/*" element={<MSignIn forced {...common({})} />} />
                    {/* <Route path="/purchase/:uuid/:method/:native" element={<MSignIn {...common({})} />} />
                    <Route path="/purchase/:uuid" element={<MSignIn {...common({})} />} />
                    <Route path="/add" element={<MSignIn {...common({})} />} />
                    <Route path="/addapp" element={<MSignIn {...common({})} />} />
                    <Route path="/editapp" element={<MSignIn {...common({})} />} />
                    <Route path="/addendpoint" element={<MSignIn {...common({})} />} />
                    <Route path="/editendpoint" element={<MSignIn {...common({})} />} />
                    <Route path="/editleg" element={<MSignIn {...common({})} />} />
                    <Route path="/editimage" element={<MSignIn {...common({})} />} /> */}
                  </>
                )}
              </Routes>
            </Router>
          </View>
          {/* </KeyboardAvoidingView> */}
        </MainContext.Provider>
      </>
    );
  }
}

MainScreen.defaultProps = {
  // position: undefined,
  config: {
    hash: '---',
    verListApps: '1.0.0',
  },
  user: null,
  userHash: undefined,
  userIdentity: undefined,
  userData: null,
  updateUserData: () => null,
  onUpdateUser: () => null,
};

MainScreen.propTypes = {
  config: PropTypes.object,
  user: PropTypes.object,
  userHash: PropTypes.string,
  userIdentity: PropTypes.string,
  userData: PropTypes.object,
  updateUserData: PropTypes.func,
  onUpdateUser: PropTypes.func,
};

const withApolloProvider = (Comp) => (props) => (
  <ApolloProvider client={AppSyncClientUnauthenticated}>
    <Comp style={styles.view.main} {...props} />
  </ApolloProvider>
);

export default withApolloProvider(withAuthentication(withConfiguration(withUserData(MainScreen))));
